module.exports = __webpack_public_path__ + "static/media/rush_bookmark_groucho_back2_2x.d2dc6b6b.jpg";